export default "/_nuxt/fonts/Avenir.ttc";